/* eslint-disable quotes */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useRef, useState } from 'react';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Icon, IconButton, InputAdornment, LinearProgress, MenuItem, Paper, Snackbar, SnackbarCloseReason, TextField, alpha, useTheme } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import * as yup from 'yup';

dayjs.locale('pt-br');
import { VTextField, VForm, useVForm, IVFormErrors, VFieldMoneyNumber2, AutoCompleteMunicipio, SelectNumber, VTextFieldCpfCnpj, AutoCompleteOperacoes, AutoCompleteOperacoes01, AutoCompleteParceiro, AutoCompletePlanoDeContas01, AutoCompleteContaBancaria, AutoCompletePlanoDeContas, VSwitch, VTextFieldNumber, BasicSelect } from '../../../shared/forms';
import { FerramentasDeDetalhe, TelaBloqueioSalvando } from '../../../shared/components';
import { useBloqueioSalvamento } from '../../../shared/hooks';
import { LayoutBaseDePaginaColaborador } from '../../../shared/layouts';
import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import { styled } from '@mui/material/styles';
import { ProdutorService } from '../../../shared/services/api/cadastros/ProdutorService';
import { EmpresaService } from '../../../shared/services/api/cadastros/Empresa';

type NullableDate = Date | null | undefined;
interface IFormData {
  idempresa: string;
  nome: string;
  cnpj: string;
  fantasia: string;
  endereco: string;
  numero: string;
  bairro: string;
  idmunicipio: string;
  uf: string;
  cep: string;
  telefone: string;
  cnae: number;
  crt: number;
  ie: string;
  csc: string;
  cscid: string;
  certificado: string;
  logo: string;
  serie55: number;
  serie65: number;
  tpamb: number;
  senha: string;
  decimais: number;
  refs: boolean;
  tipoimp: number;
  margem: number;
  est: boolean;
  emailcontador: string;
  comissao: boolean;
  enviaremailcontador: boolean;
  // Contador (registro 0100 do SPED) e SPED Fiscal — todos opcionais.
  contadornome?: string;
  contadorcpf?: string;
  contadorcrc?: string;
  contadorcnpj?: string;
  contadorcep?: string;
  contadorendereco?: string;
  contadornumero?: string;
  contadorcomplemento?: string;
  contadorbairro?: string;
  contadorfone?: string;
  contadoremail?: string;
  contadoridmunicipio?: string;
  spedperfil?: string;
  spedatividade?: number;
}
const formValidationSchema: yup.ObjectSchema<Omit<IFormData, 'idempresa' | 'logo' | 'certificado'>> = yup.object().shape({
  nome: yup.string().required(),
  cnpj: yup.string().required(),
  fantasia: yup.string().required(),
  endereco: yup.string().required(),
  numero: yup.string().required(),
  margem: yup.number().required(),
  bairro: yup.string().required(),
  idmunicipio: yup.string().required(),
  uf: yup.string().required(),
  cep: yup.string().required(),
  telefone: yup.string().required(),
  cnae: yup.number().required(),
  crt: yup.number().required(),
  ie: yup.string().required(),
  csc: yup.string().required(),
  cscid: yup.string().required(),
  serie55: yup.number().required(),
  serie65: yup.number().required(),
  tpemis: yup.number().required(),
  tpamb: yup.number().required(),
  senha: yup.string().required(),
  decimais: yup.number().required(),
  refs: yup.boolean().required().default(false),
  tipoimp: yup.number().required().default(2),
  est: yup.boolean().required().default(false),
  emailcontador: yup.string().email().default(''),
  comissao: yup.boolean().required().default(false),
  enviaremailcontador: yup.boolean().required().default(false),
  // Contador e SPED: nada obrigatório — só confere o formato do que for preenchido.
  contadornome: yup.string().optional().default(''),
  contadorcpf: yup.string().optional().default('')
    .test('cpf', 'CPF deve ter 11 dígitos', (v) => !v || v.replace(/\D/g, '').length === 11),
  contadorcrc: yup.string().optional().default(''),
  contadorcnpj: yup.string().optional().default('')
    .test('cnpj', 'CNPJ deve ter 14 dígitos', (v) => !v || v.replace(/\D/g, '').length === 14),
  contadorcep: yup.string().optional().default(''),
  contadorendereco: yup.string().optional().default(''),
  contadornumero: yup.string().optional().default(''),
  contadorcomplemento: yup.string().optional().default(''),
  contadorbairro: yup.string().optional().default(''),
  contadorfone: yup.string().optional().default(''),
  contadoremail: yup.string().optional().default('').email('E-mail inválido'),
  contadoridmunicipio: yup.string().optional().default(''),
  spedperfil: yup.string().optional().default('A'),
  spedatividade: yup.number().optional().default(1),
});
const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: '12px',
  boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
  backgroundColor: theme.palette.background.paper,
}));

const ModernLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 6,
  borderRadius: 3,
  marginBottom: theme.spacing(2),
}));

const RoundedTextField = styled(VTextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '12px',
    backgroundColor: theme.palette.background.default,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  '& .MuiInputLabel-root': {
    color: theme.palette.text.secondary,
  },
}));
const SectionBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: '12px',
  backgroundColor: theme.palette.mode === 'dark'
    ? alpha(theme.palette.background.default, 0.5)
    : alpha('#f5f5f5', 0.3),
  marginBottom: theme.spacing(2),
  border: `1px solid ${theme.palette.divider}`,
}));
const ContentContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  paddingLeft: 0,
  paddingRight: 0,
  marginLeft: 0,
  marginRight: 0,
  width: '100%',
  maxWidth: '100%',
}));

const QTD_MESES_FECHADOS = 24;

const capitalizar = (texto: string) => texto.charAt(0).toUpperCase() + texto.slice(1);

const gerarMesesFechados = () => {
  const mesAtual = dayjs().startOf('month');
  return Array.from({ length: QTD_MESES_FECHADOS }, (_, index) => {
    const referencia = mesAtual.subtract(index, 'month');
    return {
      ano: referencia.format('YYYY'),
      mes: referencia.format('MM'),
      mesLabel: capitalizar(referencia.format('MMMM')),
    };
  });
};

const gerarAnosDisponiveis = (mesesFechados: ReturnType<typeof gerarMesesFechados>) =>
  Array.from(new Set(mesesFechados.map((m) => m.ano)));

export const DetalheDeEmpresa: React.FC = () => {
  const theme = useTheme();
  const [urlimg, setUrlimg] = useState('');
  const { id = 'novo' } = useParams<'id'>();
  const navigate = useNavigate();
  const { formRef, save, saveAndClose } = useVForm();
  const [isLoading, setIsLoading] = useState(false);
  const { isSaving, progress: saveProgress, iniciar: iniciarSalvamento, concluir: concluirSalvamento, cancelar: cancelarSalvamento } = useBloqueioSalvamento();
  const [image, setImage] = useState<string | null>(null);
  // `image` some ser sempre uma URL não-vazia (window.env.REACT_APP_URL_IMGLOG + logo, mesmo
  // com logo=''), então o <img> tentava carregar e mostrava o ícone de imagem quebrada do
  // navegador em vez do Avatar padrão — isto marca esse caso pra cair no fallback.
  const [imagemComErro, setImagemComErro] = useState(false);
  const [selectedImage, setSelectedImage] = useState<File | undefined>();
  const [selectedCert, setSelectedCert] = useState<File | undefined>();
  const [certificado, setcertificado] = useState('');
  const [idempresa, setId] = useState('');
  const [nome, setNome] = useState('');
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openSenha, setOpenSenha] = useState(false);
  const [novaSenha, setNovaSenha] = useState('');
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const senhaRef = useRef('');

  const [openZip, setOpenZip] = useState(false);
  const [mesAnoZip, setMesAnoZip] = useState(() => dayjs().subtract(1, 'month').format('YYYY-MM'));
  const [tipoZip, setTipoZip] = useState<'nfe' | 'nfce'>('nfe');
  const [isBaixandoZip, setIsBaixandoZip] = useState(false);

  const [openEmailContador, setOpenEmailContador] = useState(false);
  const mesesFechados = React.useMemo(() => gerarMesesFechados(), []);
  const anosDisponiveis = React.useMemo(() => gerarAnosDisponiveis(mesesFechados), [mesesFechados]);
  const [anoEmailContador, setAnoEmailContador] = useState(() => mesesFechados[0].ano);
  const [mesEmailContador, setMesEmailContador] = useState(() => mesesFechados[0].mes);
  const [isEnviandoEmailContador, setIsEnviandoEmailContador] = useState(false);

  const mesesDoAnoSelecionado = React.useMemo(
    () => mesesFechados.filter((m) => m.ano === anoEmailContador),
    [mesesFechados, anoEmailContador]
  );

  const handleTrocarAnoEmailContador = (novoAno: string) => {
    setAnoEmailContador(novoAno);
    const meses = mesesFechados.filter((m) => m.ano === novoAno);
    if (meses.length > 0 && !meses.some((m) => m.mes === mesEmailContador)) {
      setMesEmailContador(meses[0].mes);
    }
  };

  const handleAbrirSenha = () => {
    setNovaSenha(senhaRef.current || '');
    setMostrarSenha(false);
    setOpenSenha(true);
  };

  const handleFecharSenha = () => {
    setOpenSenha(false);
    setNovaSenha('');
  };

  const handleConfirmarSenha = () => {
    senhaRef.current = novaSenha;
    setOpenSenha(false);
    setNovaSenha('');
    save();
  };

  const handleAbrirZip = () => {
    setOpenZip(true);
  };

  const handleFecharZip = () => {
    setOpenZip(false);
  };

  const handleAbrirEmailContador = () => {
    setOpenEmailContador(true);
  };

  const handleFecharEmailContador = () => {
    setOpenEmailContador(false);
  };

  const handleEnviarEmailContador = () => {
    setIsEnviandoEmailContador(true);
    EmpresaService.enviarEmailContador(`${anoEmailContador}-${mesEmailContador}`)
      .then((result) => {
        setIsEnviandoEmailContador(false);
        if (result instanceof Error) {
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
          return;
        }
        setOpenEmailContador(false);
        setTms('success');
        setMsg('Notas enviadas para a contabilidade com sucesso!');
        setOpenmsg(true);
      });
  };

  const handleBaixarZip = () => {
    setIsBaixandoZip(true);
    EmpresaService.baixarZipNfe(mesAnoZip, tipoZip)
      .then((result) => {
        setIsBaixandoZip(false);
        if (result instanceof Error) {
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
          return;
        }
        const blob = new Blob([result], { type: 'application/zip' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${tipoZip}_${mesAnoZip}.zip`;
        link.click();
        setTimeout(() => URL.revokeObjectURL(url), 10000);
        setOpenZip(false);
      });
  };

  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
    if (tms === 'success') {
      navigate('/empresa');
    }
  };
  const handleDelete = () => {
    setOpenConfirm(true);
  };
  useEffect(() => {
    return () => {
      if (image?.startsWith('blob:')) {
        URL.revokeObjectURL(image);
      }
    };
  }, [image]);
  const handleConfirmDelete = () => {
    ProdutorService.deleteById(id)
      .then(result => {
        if (result instanceof Error) {
          setOpenConfirm(false);
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          setOpenConfirm(false);
          setTms('success');
          setMsg('Registro apagado com sucesso!');
          setOpenmsg(true);
        }
      });
  };

  const handleCancelDelete = () => {
    setOpenConfirm(false);
  };

  useEffect(() => {

    setIsLoading(true);
    EmpresaService.getById()
      .then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          setNome(result.nome);
          setId(result.idempresa)
          setUrlimg(result.logo);
          setImagemComErro(false);
          setImage(result.logo ? window.env.REACT_APP_URL_IMGLOG + result.logo : null);
          setcertificado(result.certificado);
          senhaRef.current = result.senha;
          formRef.current?.setData(result);
        }
      });
  }, [id]);

  const handleSave = (dadosOriginais: IFormData) => {
    if (!iniciarSalvamento()) return;

    const dados: IFormData = { ...dadosOriginais, senha: senhaRef.current };
    const { logo, ...dadosSemCampos } = dados;
    formValidationSchema
      .validate(dadosSemCampos, { abortEarly: false })
      .then(async () => {
        setIsLoading(true);
        const result = await EmpresaService.updateById(idempresa, dados);
        if (result instanceof Error) {
          setIsLoading(false);
          cancelarSalvamento();
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
          return;
        }
        if (selectedImage) {
          const imgResult = await EmpresaService.updateByIdImg(
            idempresa,
            selectedImage,
            urlimg
          );
          if (imgResult instanceof Error) {
            setIsLoading(false);
            cancelarSalvamento();
            setTms('error');
            setMsg(imgResult.message);
            setOpenmsg(true);
            return;
          }
        }
        if (selectedCert) {
          const certResult = await EmpresaService.updateByIdCert(
            idempresa,
            selectedCert,
            certificado
          );
          if (certResult instanceof Error) {
            setIsLoading(false);
            cancelarSalvamento();
            setTms('error');
            setMsg(certResult.message);
            setOpenmsg(true);
            return;
          }
        }
        setIsLoading(false);
        setTms('success');
        setMsg('Alteração concluída com sucesso!');
        setOpenmsg(true);
        concluirSalvamento();
      })
      .catch((errors: yup.ValidationError) => {
        cancelarSalvamento();
        const validationErrors: IVFormErrors = {};
        errors.inner.forEach(error => {
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });

        formRef.current?.setErrors(validationErrors);
      });
  };

  return (
    <>
      <TelaBloqueioSalvando
        open={isSaving}
        message="Salvando dados da empresa..."
        progress={saveProgress}
      />
      <LayoutBaseDePaginaColaborador
        barraDeFerramentas={
          <FerramentasDeDetalhe
            textoBotaoNovo='Novo'
            mostrarBotaoSalvarEFechar={false}
            mostrarBotaoSalvarCarregando={false}
            mostrarBotaoSalvarEFecharCarregando={isLoading}
            disableBotaoSalvar={isLoading || isSaving}
            mostrarBotaoNovo={id !== 'novo'}
            mostrarBotaoApagar={id !== 'novo'}
            mostrarBotaoApagarCarregando={isLoading}
            mostrarBotaoImpressao={false}
            mostrarBotaoHistorico={false}
            mostrarBotaoferais={false}
            mostrarBotaoauxilio={false}
            mostrarBotaoHistoricoCarregando={false}
            mostrarBotaoferaisCarregando={isLoading}
            mostrarBotaoauxilioCarregando={isLoading}
            mostrarBotaoCartaoPonto={false}
            mostrarBotaoCartaoPontoCarregando={isLoading}
            mostrarBotaoCartaoPontoVerso={false}
            mostrarBotaoCartaoPontoVersoCarregando={isLoading}
            aoClicarEmSalvar={save}
            aoClicarEmVoltar={() => navigate('/produtos')}
            mostrarBotaoVoltarCarregando={isLoading}
            aoClicarEmApagar={() => handleDelete()}
            aoClicarEmNovo={() => navigate('/produto/novo')}
            mostrarBotaoNovoCarregando={isLoading}
          />
        }
      >
        <VForm ref={formRef} onSubmit={handleSave} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg} autoHideDuration={tms === 'error' ? null : 900} onClose={handleCloseMsg}>
            <Alert
              onClose={handleCloseMsg}
              severity={tms}
              variant="filled"
              sx={{
                width: '100%',
                borderRadius: '12px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
              }}
            >
              {msg}
            </Alert>
          </Snackbar>
          <Snackbar open={openConfirm} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
            <Alert
              severity="warning"
              variant="filled"
              sx={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                borderRadius: '12px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
              }}
              action={
                <>
                  <Button color="inherit" size="small" onClick={handleConfirmDelete}>
                    Sim
                  </Button>
                  <Button color="inherit" size="small" onClick={handleCancelDelete}>
                    Nâo
                  </Button>
                </>
              }
            >
              Tem certeza que deseja excluir este registro?
            </Alert>
          </Snackbar>
          <Dialog open={openSenha} onClose={handleFecharSenha} maxWidth="xs" fullWidth>
            <DialogTitle>Alterar Senha</DialogTitle>
            <DialogContent dividers>
              <TextField
                fullWidth
                autoFocus
                size="small"
                label="Nova Senha"
                type={mostrarSenha ? 'text' : 'password'}
                value={novaSenha}
                onChange={(e) => setNovaSenha(e.target.value)}
                autoComplete="new-password"
                inputProps={{
                  autoComplete: 'new-password',
                  'data-lpignore': 'true',
                  'data-1p-ignore': 'true',
                }}
                sx={{ mt: 1 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setMostrarSenha((old) => !old)}>
                        {mostrarSenha ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </DialogContent>
            <DialogActions>
              <Button variant="outlined" color="error" onClick={handleFecharSenha}>
                Cancelar
              </Button>
              <Button
                variant="contained"
                disabled={!novaSenha}
                onClick={handleConfirmarSenha}
              >
                Confirmar
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog open={openZip} onClose={handleFecharZip} maxWidth="xs" fullWidth>
            <DialogTitle>Baixar Notas (ZIP)</DialogTitle>
            <DialogContent dividers>
              <Box display="flex" flexDirection="column" gap={2} sx={{ mt: 1 }}>
                <TextField
                  fullWidth
                  size="small"
                  label="Mês/Ano"
                  type="month"
                  value={mesAnoZip}
                  disabled={isBaixandoZip}
                  onChange={(e) => setMesAnoZip(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  fullWidth
                  select
                  size="small"
                  label="Tipo"
                  value={tipoZip}
                  disabled={isBaixandoZip}
                  onChange={(e) => setTipoZip(e.target.value as 'nfe' | 'nfce')}
                >
                  <MenuItem value="nfe">NF-e</MenuItem>
                  <MenuItem value="nfce">NFC-e</MenuItem>
                </TextField>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button variant="outlined" color="error" onClick={handleFecharZip} disabled={isBaixandoZip}>
                Cancelar
              </Button>
              <Button
                variant="contained"
                disabled={!mesAnoZip || isBaixandoZip}
                onClick={handleBaixarZip}
                startIcon={<Icon>folder_zip</Icon>}
              >
                Baixar
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog open={openEmailContador} onClose={handleFecharEmailContador} maxWidth="xs" fullWidth>
            <DialogTitle>Enviar Notas para a Contabilidade</DialogTitle>
            <DialogContent dividers>
              <Box display="flex" gap={2} sx={{ mt: 1 }}>
                <TextField
                  select
                  size="small"
                  label="Ano"
                  value={anoEmailContador}
                  disabled={isEnviandoEmailContador}
                  onChange={(e) => handleTrocarAnoEmailContador(e.target.value)}
                  sx={{ width: '40%' }}
                >
                  {anosDisponiveis.map((ano) => (
                    <MenuItem key={ano} value={ano}>
                      {ano}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  select
                  size="small"
                  label="Mês"
                  value={mesEmailContador}
                  disabled={isEnviandoEmailContador}
                  onChange={(e) => setMesEmailContador(e.target.value)}
                  sx={{ width: '60%' }}
                >
                  {mesesDoAnoSelecionado.map((mes) => (
                    <MenuItem key={mes.mes} value={mes.mes}>
                      {mes.mesLabel}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
              <Alert severity="info" variant="outlined" sx={{ mt: 2, borderRadius: '8px' }}>
                Meses futuros não podem ser enviados
              </Alert>
            </DialogContent>
            <DialogActions>
              <Button variant="outlined" color="error" onClick={handleFecharEmailContador} disabled={isEnviandoEmailContador}>
                Cancelar
              </Button>
              <Button
                variant="contained"
                disabled={isEnviandoEmailContador}
                onClick={handleEnviarEmailContador}
                startIcon={<Icon>mail</Icon>}
              >
                Enviar
              </Button>
            </DialogActions>
          </Dialog>
          <ContentContainer>
            <StyledPaper elevation={0} sx={{ marginLeft: 0, marginRight: 0 }}>
              <Grid container direction="column" spacing={3}>
                <Grid item>
                  <Box display="flex" justifyContent="flex-end" gap={2}>
                    <Button
                      variant="outlined"
                      onClick={handleAbrirEmailContador}
                      startIcon={<Icon>mail</Icon>}
                      sx={{ borderRadius: '12px', textTransform: 'none' }}
                    >
                      Enviar Notas para Contabilidade
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={handleAbrirZip}
                      startIcon={<Icon>folder_zip</Icon>}
                      sx={{ borderRadius: '12px', textTransform: 'none' }}
                    >
                      Baixar NF-e / NFC-e
                    </Button>
                  </Box>
                </Grid>
                {isLoading && (
                  <Grid item>
                    <ModernLinearProgress variant='indeterminate' />
                  </Grid>
                )}
                <Grid item>
                  <SectionBox>
                    <Grid container spacing={2} alignItems="center" >
                      <Grid item xs={12} sm={12} md={2.5} lg={3} xl={3}>
                        <Box width="100%" display="flex" justifyContent="center">
                          <input
                            id="avatar-input"
                            type="file"
                            accept="image/*"
                            hidden
                            onChange={(event) => {
                              const file = event.target.files?.[0];
                              if (!file) return;
                              setSelectedImage(file);
                              const preview = URL.createObjectURL(file);
                              setImagemComErro(false);
                              setImage(preview);
                            }}
                          />
                          <label htmlFor="avatar-input" style={{ cursor: 'pointer', width: '100%' }}>
                            <Box
                              sx={{
                                width: '100%',
                                aspectRatio: '1 / 1',
                                borderRadius: '12px',
                                backgroundColor:
                                  theme.palette.mode === 'dark' ? '#424242' : '#f5f5f5',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                overflow: 'hidden',
                              }}
                            >
                              {image && !imagemComErro ? (
                                <Box
                                  component="img"
                                  src={image}
                                  alt="logo"
                                  onError={() => setImagemComErro(true)}
                                  sx={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain',
                                  }}
                                />
                              ) : (
                                <Avatar variant="rounded" sx={{ width: '100%', height: '100%', backgroundColor: 'transparent' }} />
                              )}
                            </Box>
                          </label>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={12} md={9.5} lg={9} xl={9}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                            <RoundedTextField
                              fullWidth
                              size='small'
                              name='nome'
                              disabled={isLoading}
                              label='Nome'
                            />
                          </Grid>

                          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                            <RoundedTextField
                              fullWidth
                              size='small'
                              name='fantasia'
                              disabled={isLoading}
                              label='Fantasia'
                            />
                          </Grid>
                          <Grid item xs={6} sm={6} md={6} lg={3} xl={3}>
                            <VTextFieldCpfCnpj
                              fullWidth
                              size='small'
                              name='cnpj'
                              disabled={true}
                              label='CNPJ'
                            />
                          </Grid>
                          <Grid item xs={6} sm={6} md={6} lg={3} xl={3}>
                            <RoundedTextField
                              fullWidth
                              size='small'
                              name='ie'
                              disabled={true}
                              label='INSC. ESTADUAL'
                            />
                          </Grid>
                          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                            <RoundedTextField
                              fullWidth
                              size='small'
                              name='telefone'
                              disabled={isLoading}
                              label='Telefone'
                            />
                          </Grid>
                          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                            <RoundedTextField
                              fullWidth
                              size='small'
                              name='endereco'
                              disabled={isLoading}
                              label='Endereço'
                            />
                          </Grid>
                          <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                            <RoundedTextField
                              fullWidth
                              size='small'
                              name='numero'
                              disabled={isLoading}
                              label='Numero'
                            />
                          </Grid><Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                            <RoundedTextField
                              fullWidth
                              size='small'
                              name='bairro'
                              disabled={isLoading}
                              label='Bairro'
                            />
                          </Grid><Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                            <AutoCompleteMunicipio
                            />
                          </Grid>

                          <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                            <RoundedTextField
                              fullWidth
                              size='small'
                              name='uf'
                              disabled={isLoading}
                              label='UF'
                            />
                          </Grid>
                          <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                            <RoundedTextField
                              fullWidth
                              size="small"
                              name="cep"
                              disabled={isLoading}
                              label="CEP"
                            />
                          </Grid>
                          <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                            <input
                              id="cert-input"
                              type="file"
                              accept=".pfx"
                              hidden
                              onChange={(event) => {
                                const file = event.target.files?.[0];
                                if (!file) return;
                                setSelectedCert(file);
                              }}
                            />
                            <label htmlFor="cert-input">
                              <Button
                                fullWidth
                                variant="outlined"
                                component="span"
                                disabled={isLoading}
                                sx={{
                                  height: '40px',
                                  borderRadius: '12px',
                                  justifyContent: 'space-between',
                                  textTransform: 'none',
                                }}
                              >
                                {selectedCert ? selectedCert.name : 'Certificado (.pfx)'}
                              </Button>
                            </label>
                          </Grid>
                          <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                            <Button
                              fullWidth
                              variant="outlined"
                              disabled={isLoading}
                              onClick={handleAbrirSenha}
                              startIcon={<Icon>lock</Icon>}
                              sx={{
                                height: '40px',
                                borderRadius: '12px',
                                textTransform: 'none',
                              }}
                            >
                              Alterar Senha
                            </Button>
                          </Grid>
                          <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                            <SelectNumber
                              name='decimais'
                              label='Casas Decimais'
                              data={[
                                { nameBD: 2, descricao: '2' },
                                { nameBD: 4, descricao: '4' },

                              ]}
                              disabled={isLoading}
                            />
                          </Grid>
                          <Grid item xs={3} sm={3} md={2} lg={2} xl={2}>
                            <SelectNumber
                              name='tipoimp'
                              label='tipo de impressão'
                              data={[
                                { nameBD: 1, descricao: '1' },
                                { nameBD: 2, descricao: '2' },

                              ]}
                              disabled={isLoading}
                            />
                          </Grid>
                          <Grid item xs={3} sm={3} md={2} lg={2} xl={2}>
                            <VTextFieldNumber
                              fullWidth
                              size='small'
                              name='margem'
                              disabled={isLoading}
                              label='Margem de Lucro (%)'
                            /> </Grid>
                             <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                            <RoundedTextField
                              fullWidth
                              size='small'
                              type='email'
                              name='emailcontador'
                              disabled={isLoading}
                              label='E-mail do Contador'
                            />
                          </Grid>
                          <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                            <VSwitch
                              name='refs'
                              label='Referência'
                              fdisabled={isLoading}
                              aliamento='start'
                            />
                          </Grid>


                          <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                            <VSwitch
                              name='est'
                              label='Estoque'
                              fdisabled={isLoading}
                              aliamento='start'
                            />
                          </Grid>
                          <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                            <VSwitch
                              name='comissao'
                              label='Comissão'
                              fdisabled={isLoading}
                              aliamento='start'
                            />
                          </Grid>
                          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                            <VSwitch
                              name='enviaremailcontador'
                              label='Enviar XML de Cada Nota ao Contador'
                              fdisabled={isLoading}
                              aliamento='start'
                            />
                          </Grid>

                        </Grid>
                      </Grid>
                    </Grid>
                  </SectionBox>
                </Grid>
                <Grid container spacing={2} sx={{ mt: 0 }} marginLeft={0} marginTop={0}>
                  <Grid item xs={12} md={12} xl={12}>
                    <SectionBox>
                      <Grid container spacing={2}>
                        <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                          <VFieldMoneyNumber2
                            fullWidth
                            size='small'
                            name='cnae'
                            label='CNAE'
                            disabled={false}
                          />
                        </Grid> <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                          <SelectNumber
                            name='tpemis'
                            label='Tipo de Emissão'
                            data={[
                              { nameBD: 1, descricao: 'Emissão normal (não em contingência)' },
                              { nameBD: 2, descricao: 'Contingência FS-IA, com impressão do DANFE em formulário de segurança' },
                              { nameBD: 3, descricao: 'Contingência SCAN (Sistema de Contingência do Ambiente Nacional)' },
                              { nameBD: 4, descricao: 'Contingência DPEC (Declaração Prévia da Emissão em Contingência)' },
                              { nameBD: 5, descricao: 'Contingência FS-DA, com impressão do DANFE em formulário de segurança' },
                              { nameBD: 6, descricao: 'Contingência SVC-AN (SEFAZ Virtual de Contingência do AN)' },
                              { nameBD: 7, descricao: 'Contingência SVC-RS (SEFAZ Virtual de Contingência do RS)' },
                            ]}
                            disabled={isLoading}
                          />
                        </Grid>
                        <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                          <SelectNumber
                            name='tpamb'
                            label='Tipo de Emissão'
                            data={[
                              { nameBD: 1, descricao: 'Produção' },
                              { nameBD: 2, descricao: 'Homologação' },
                            ]}
                            disabled={isLoading}
                          />
                        </Grid>
                        <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                          <SelectNumber
                            name='crt'
                            label='CRT Empresa'
                            data={[
                              { nameBD: 1, descricao: 'Simples Nacional' },
                              { nameBD: 2, descricao: 'Simples Nacional - excesso de sublimite da receita bruta' },
                              { nameBD: 3, descricao: 'Regime Normal' },
                            ]}
                            disabled={isLoading}
                          />
                        </Grid>

                        <Grid item xs={3} sm={3} md={1} lg={1} xl={1}>
                          <VFieldMoneyNumber2
                            fullWidth
                            size='small'
                            name='serie55'
                            label='Serie 55'
                            disabled={false}
                          />
                        </Grid>
                        <Grid item xs={3} sm={3} md={1} lg={1} xl={1}>
                          <VFieldMoneyNumber2
                            fullWidth
                            size='small'
                            name='serie65'
                            label='Serie 65'
                            disabled={false}
                          />
                        </Grid>
                        <Grid item xs={6} sm={6} md={1} lg={1} xl={1}>
                          <RoundedTextField
                            fullWidth
                            size='small'
                            name='cscid'
                            disabled={isLoading}
                            label='CSCID'
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
                          <RoundedTextField
                            fullWidth
                            size='small'
                            name='csc'
                            disabled={isLoading}
                            label='CSC'
                          />
                        </Grid>
                      </Grid>
                    </SectionBox>
                  </Grid>
                </Grid>
                {/* Contador e SPED Fiscal — tudo opcional. Usados na geração do
                    SPED (Fiscal → SPED Fiscal): o contador vai no registro 0100 e
                    o perfil/atividade no 0000. */}
                <Grid container spacing={2} sx={{ mt: 0 }} marginLeft={0} marginTop={0}>
                  <Grid item xs={12}>
                    <SectionBox>
                      <Box display="flex" alignItems="center" gap={1} mb={0.5}>
                        <Icon color="primary">badge</Icon>
                        <Box component="span" sx={{ fontWeight: 700 }}>Contador (opcional)</Box>
                      </Box>
                      <Box component="p" sx={{ mt: 0, mb: 2, color: 'text.secondary', fontSize: '0.85rem' }}>
                        Usados no SPED Fiscal. Não são obrigatórios aqui, mas o programa da Receita exige nome, CPF, CRC e contato do contador para validar o arquivo.
                      </Box>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <RoundedTextField fullWidth size='small' name='contadornome' disabled={isLoading} label='Nome do contador' />
                        </Grid>
                        <Grid item xs={6} md={3}>
                          <RoundedTextField fullWidth size='small' name='contadorcpf' disabled={isLoading} label='CPF do contador' inputProps={{ inputMode: 'numeric' }} />
                        </Grid>
                        <Grid item xs={6} md={3}>
                          <RoundedTextField fullWidth size='small' name='contadorcrc' disabled={isLoading} label='CRC' placeholder='Ex.: SP-123456/O-0' />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <RoundedTextField fullWidth size='small' name='contadorcnpj' disabled={isLoading} label='CNPJ do escritório (se houver)' inputProps={{ inputMode: 'numeric' }} />
                        </Grid>
                        <Grid item xs={6} md={4}>
                          <RoundedTextField fullWidth size='small' name='contadorfone' disabled={isLoading} label='Telefone' inputProps={{ inputMode: 'tel' }} />
                        </Grid>
                        <Grid item xs={6} md={4}>
                          <RoundedTextField fullWidth size='small' type='email' name='contadoremail' disabled={isLoading} label='E-mail do contador' />
                        </Grid>
                        <Grid item xs={6} md={2}>
                          <RoundedTextField fullWidth size='small' name='contadorcep' disabled={isLoading} label='CEP' inputProps={{ inputMode: 'numeric' }} />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <RoundedTextField fullWidth size='small' name='contadorendereco' disabled={isLoading} label='Endereço' />
                        </Grid>
                        <Grid item xs={6} md={1.5}>
                          <RoundedTextField fullWidth size='small' name='contadornumero' disabled={isLoading} label='Número' />
                        </Grid>
                        <Grid item xs={12} md={2.5}>
                          <RoundedTextField fullWidth size='small' name='contadorcomplemento' disabled={isLoading} label='Complemento' />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <RoundedTextField fullWidth size='small' name='contadorbairro' disabled={isLoading} label='Bairro' />
                        </Grid>
                        <Grid item xs={12} md={8}>
                          <AutoCompleteMunicipio name='contadoridmunicipio' label='Cidade do escritório do contador' isExternalLoading={isLoading} />
                        </Grid>
                      </Grid>
                    </SectionBox>
                  </Grid>
                  <Grid item xs={12}>
                    <SectionBox>
                      <Box display="flex" alignItems="center" gap={1} mb={0.5}>
                        <Icon color="primary">description</Icon>
                        <Box component="span" sx={{ fontWeight: 700 }}>SPED Fiscal</Box>
                      </Box>
                      <Box component="p" sx={{ mt: 0, mb: 2, color: 'text.secondary', fontSize: '0.85rem' }}>
                        O regime tributário (CRT, acima) define como o ICMS sai no SPED. Perfil e atividade são informados pelo contador — na dúvida, deixe como está (Perfil A, Comércio/serviços).
                      </Box>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <BasicSelect
                            name='spedperfil'
                            label='Perfil do SPED'
                            data={[
                              { nameBD: 'A', descricao: 'Perfil A — mais detalhado (o mais comum)' },
                              { nameBD: 'B', descricao: 'Perfil B — totalizado' },
                              { nameBD: 'C', descricao: 'Perfil C — simplificado' },
                            ]}
                            disabled={isLoading}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <SelectNumber
                            name='spedatividade'
                            label='Tipo de atividade'
                            data={[
                              { nameBD: 1, descricao: 'Comércio / serviços (outros)' },
                              { nameBD: 0, descricao: 'Industrial ou equiparado a industrial' },
                            ]}
                            disabled={isLoading}
                          />
                        </Grid>
                      </Grid>
                    </SectionBox>
                  </Grid>
                </Grid>
              </Grid>
            </StyledPaper>
          </ContentContainer>
        </VForm >
      </LayoutBaseDePaginaColaborador >
    </>
  );
};
